<div>
  <div class="hero"></div>
  <div>
    <div class="success-container">
      <div>
        <h3>Your membership has been cancelled</h3>

        <div *ngIf="giftItemsLength > 0" class="alert alert-warning">
          <strong>NOTE:</strong> You have <strong>{{giftItemsLength}}</strong> active recurring gift subscription(s). They will continue to be charged even though your membership is now canceled.
          <a href="/settings/memberships">Click here to visit your Memberships page</a> and click "My Gift Accounts" to manage your current gifts.
        </div>

        <p>
          <app-notice></app-notice>
        </p>
        <p>
          <a routerLink="/account">Back to Account</a>
        </p>
      </div>
    </div>
  </div>
</div>
